import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CalendarClock, Bell, UserMinus, ChevronRight, CreditCard } from 'lucide-react';
import PageHeader from '../components/PageHeader';

function Settings() {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <PageHeader title={t('title')} subtitle={t('subtitle')} />
      <div className="flex-1 px-6 py-8 max-w-2xl mx-auto w-full">
        <div className="space-y-2">
          <button
            onClick={() => navigate('/settings/billing')}
            className="w-full flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 text-left hover:border-orange-300 hover:shadow-sm transition-all group"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
              <CreditCard size={20} className="text-orange-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-900">{t('billing.title')}</div>
              <div className="text-xs text-gray-500 mt-0.5">{t('billing.description')}</div>
            </div>
            <ChevronRight size={16} className="text-gray-400 group-hover:text-orange-400 transition-colors flex-shrink-0" />
          </button>

          <button
            onClick={() => navigate('/settings/shift-types')}
            className="w-full flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 text-left hover:border-orange-300 hover:shadow-sm transition-all group"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
              <CalendarClock size={20} className="text-orange-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-900">{t('shiftTypes.title')}</div>
              <div className="text-xs text-gray-500 mt-0.5">{t('shiftTypes.description')}</div>
            </div>
            <ChevronRight size={16} className="text-gray-400 group-hover:text-orange-400 transition-colors flex-shrink-0" />
          </button>

          <button
            onClick={() => navigate('/settings/notifications')}
            className="w-full flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 text-left hover:border-orange-300 hover:shadow-sm transition-all group"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
              <Bell size={20} className="text-orange-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-900">{t('notifications.title')}</div>
              <div className="text-xs text-gray-500 mt-0.5">{t('notifications.description')}</div>
            </div>
            <ChevronRight size={16} className="text-gray-400 group-hover:text-orange-400 transition-colors flex-shrink-0" />
          </button>

          <button
            onClick={() => navigate('/settings/deactivation-shifts')}
            className="w-full flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 text-left hover:border-orange-300 hover:shadow-sm transition-all group"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
              <UserMinus size={20} className="text-orange-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-900">{t('deactivation.title')}</div>
              <div className="text-xs text-gray-500 mt-0.5">{t('deactivation.description')}</div>
            </div>
            <ChevronRight size={16} className="text-gray-400 group-hover:text-orange-400 transition-colors flex-shrink-0" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Settings;